import { doesExist } from '@utils';

export default function ordersApi(fetch, baseUrl) {
  return {
    orders(pageNo = 0, pageSize = 10) {
      return fetch(`${baseUrl}?page_size=${pageSize}&page=${pageNo}`);
    },

    ordersV2(pageNo = 0, pageSize = 10) {
      return fetch(`${baseUrl}?page_size=${pageSize}&page=${pageNo}`);
    },

    gomsOrders(pageNo = 0, pageSize = 10) {
      return fetch(`${baseUrl}/goms?page_size=${pageSize}&page=${pageNo}`);
    },

    getOrderDetailsSidebar(orderId) {
      return fetch(`${baseUrl}/${orderId}/order-details`);
    },

    getGomsOrderDetailsSidebar(orderId) {
      return fetch(`${baseUrl}/${orderId}/order-details/goms`);
    },

    funnelOrdersV2({
      status,
      acquirer,
      ordersInPastHours,
      pageNo = 0,
      pageSize = 10,
      orderType
    }) {
      return fetch(
        `${baseUrl}/funnel?page=${pageNo}&page_size=${pageSize}&order_status=${status}${
          acquirer?.length ? `&acquirer=${acquirer}` : ''
        }${!ordersInPastHours ? '' : `&pending_for_hours=${ordersInPastHours}`}
        ${!orderType ? '' : `&order_type=${orderType}`}
        `
      );
    },

    funnelGomsOrders({
      status,
      acquirer,
      ordersInPastHours,
      pageNo = 0,
      pageSize = 10,
      orderType
    }) {
      return fetch(
        `${baseUrl}/funnel/goms?page=${pageNo}&page_size=${pageSize}&order_status=${status}${
          acquirer?.length ? `&acquirer=${acquirer}` : ''
        }${!ordersInPastHours ? '' : `&pending_for_hours=${ordersInPastHours}`}
        ${!orderType ? '' : `&order_type=${orderType}`}
        `
      );
    },

    luluFunnelOrders({ tab, pageNo = 0, page_size = 10 }) {
      const url = `${baseUrl}/lulu-funnel?funnel=${tab}&page=${pageNo}&page_size=${page_size}`;
      return fetch(url);
    },

    updateOrderMetadata({
      orderId: order_id,
      details,
      flag: compliance_flagged
    }) {
      const reqBody = { order_id }; //only send attributes which were updated
      if (doesExist(details)) reqBody.details = details;
      if (doesExist(compliance_flagged))
        reqBody.compliance_flagged = compliance_flagged;
      return fetch.post(`${baseUrl}/metadata`, reqBody);
    },

    updateGomsOrderMetadata({
      orderId: order_id,
      details,
      flag: compliance_flagged
    }) {
      const reqBody = { order_id }; //only send attributes which were updated
      if (doesExist(details)) reqBody.details = details;
      if (doesExist(compliance_flagged))
        reqBody.compliance_flagged = compliance_flagged;
      return fetch.patch(`${baseUrl}/metadata/goms`, reqBody);
    },

    getOrderTransferChecks({ orderId }) {
      return fetch.get(`${baseUrl}/${orderId}/checks`);
    },

    updateBeneficiaryChecks({ orderId, acctNo, riskCategory }) {
      return fetch.post(`${baseUrl}/beneficiary-risk/${orderId}`, {
        accountNumber: acctNo,
        riskCategory
      });
    },

    updateBeneficiaryDetails({ userId, beneficiaryId, payload }) {
      return fetch.put(
        `${baseUrl}/beneficiary/verification-data?user_id=${userId}&beneficiary_id=${beneficiaryId}`,
        {
          ...payload
        }
      );
    },

    getTxnMonitoringByFulfillmentId({ fulfillmentId }) {
      return fetch.get(`${baseUrl}/txn-monitoring/entity/${fulfillmentId}`);
    },

    getProviderEntityDetails({ fulfillmentId }) {
      return fetch.get(
        `${baseUrl}/txn-monitoring/provider-entity/${fulfillmentId}`
      );
    },

    reviewFulfillmentProvider({ fulfillmentId, payload }) {
      return fetch.post(
          `${baseUrl}/txn-monitoring/${fulfillmentId}/review`,
          payload
      );
    },

    getUserBeneficiaries({ userId }) {
      return fetch(`${baseUrl}/beneficiary/${userId}`);
    },

    updateBeneficiaryV2({ payload }) {
      return fetch.put(`${baseUrl}/update/beneficiary-account-type`, payload);
    },
    getNotReviewedOrderReceipts({
      pageNumber,
      pageSize,
      orderId,
      startDate,
      endDate,
      receiptStatus
    }) {
      return fetch.get(
        `${baseUrl}/order-receipts/pending?page_number=${pageNumber}&page_size=${pageSize}${
          orderId && '&order_id=' + orderId
        }&start_date=${startDate}&end_date=${endDate}&receipt_status=${receiptStatus}`
      );
    },
    acceptOrderReceipt({ receiptId, paymentReferenceId }) {
      return fetch.put(`${baseUrl}/order-receipts/accept`, {
        receiptId,
        paymentReferenceId
      });
    },
    rejectOrderReceipt({ receiptId, rejectionNote }) {
      return fetch.put(`${baseUrl}/order-receipts/reject`, {
        receiptId,
        rejectionNote
      });
    },
    getOrderReceiptLinkByResourcePath({ resourcePath }) {
      return fetch.get(
        `${baseUrl}/order-receipts/order-receipt-url?resource_path=${resourcePath}`
      );
    },
    getOrderReceiptsByOrderId({ orderId }) {
      return fetch.get(`${baseUrl}/order-receipts/${orderId}`);
    },
    getBeneficiaryVerificationData({ accountNo, ifsc }) {
      return fetch.get(
        `${baseUrl}/beneficiary/verification-data?account_no=${accountNo}&ifsc=${ifsc}`
      );
    },

    bulkSyncLuluOrders(data) {
      return fetch.post(`${baseUrl}/lulu/bulk/force-sync`, data)
    },

    getSardineOnHoldOrders({
       orderSubStatus,
       ordersInPastHours,
       pageNo = 0,
       pageSize = 10
    }) {
      return fetch(
        `${baseUrl}/on-hold/sardine/goms?page=${pageNo}&page_size=${pageSize}&order_sub_status=${orderSubStatus}${
          !ordersInPastHours ? '' : `&pending_for_hours=${ordersInPastHours}`
        }`
      );
    },

    gomsSearchOrders({ query, orderType, userId, page, pageSize }) {
      return fetch.get(
        `${baseUrl}/search/goms?query=${query}&order_type=${orderType}&userId=${userId}&page=${page}&page_size=${pageSize}`
      );
    },

  };
}
